import React from "react";
import { PrepareResultDE } from "@visonum/network-quality-sdk"
import * as R from "ramda"
import CopyableData from "./CopyableData";
import t from "../../helper/t";
import getSpeedtestId from "../../helper/utils/getSpeedtestId";
import styled from "@emotion/styled";

const RootDiv = styled.div(({ theme }) => ([
  {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: 10,
    marginRight: 20,
    marginLeft: 20,
    marginBottom: 0,

    [theme.breakpoints.tablet]: {
      flexDirection: "row",
      marginTop: 70,
    },
  },
]));


interface InfoWidgetProps {
  prepareResult: PrepareResultDE;
}

const InfoWidget: React.FC<InfoWidgetProps> = ({ prepareResult }) => {
  const items = [
    { label: t("Speedtest-ID"), value: getSpeedtestId(prepareResult), isClipboardEnabled: true },
    { label: t("IP-Adresse"), value: prepareResult.init.connection.ip },
    ...(prepareResult.init.connection.isVpnActive === true ?
      [{ label: t("VPN"), value: t("erkannt") }] :
      !R.isNil(prepareResult.init.connection.isp) ? [{ label: t("Anbieter"), value: prepareResult.init.connection.isp }] : []
    ),
  ];

  return (
    <RootDiv>
      {items.map((item, index) =>
        <InfoWidgetItem
          key={`infoWidgetItem${index}`}
          label={item.label}
          value={item.value}
          isClipboardEnabled={item.isClipboardEnabled}
          showBorder={item !== R.last(items)} />
      )}
    </RootDiv>
  );
}

interface ItemRootDivProps {
  showBorder: boolean;
}

const ItemRootDiv = styled.div<ItemRootDivProps>(({ showBorder, theme }) => ([
  theme.colors.border.secondary,
  theme.typography.regular12,
  {
    display: "flex",
    marginRight: 7,
    paddingRight: 9,
    borderWidth: 0,
    lineHeight: "16px",
    [theme.breakpoints.tablet]: {
      borderStyle: "solid",
      borderRightWidth: showBorder ? 1 : 0,
      fontSize: 14,
      lineHeight: "18px"
    },
  }
]));

const LabelDiv = styled.div(({ theme }) => ([
  theme.typography.bold,
  {
    marginRight: 3,
  }
]));

const ValueDiv = styled.div();

interface InfoWidgetItemProps {
  label: string;
  value: string;
  isClipboardEnabled?: boolean;
  showBorder: boolean;
}

const InfoWidgetItem: React.FC<InfoWidgetItemProps> = ({ label, value, showBorder, isClipboardEnabled = false }) => {
  return (
    <ItemRootDiv showBorder={showBorder}>
      <LabelDiv>{label}:</LabelDiv>
      <ValueDiv>{isClipboardEnabled ? <CopyableData value={value} /> : value}</ValueDiv>
    </ItemRootDiv>
  )
}

export default InfoWidget;